import React, { useState } from 'react';
import { useCalendar } from '../../contexts/CalendarContext';
import { ChevronDown, ChevronRight } from 'lucide-react';
import styles from './CalendarLegend.module.css';

const CalendarLegend = () => {
  const { availableCalendars, selectedCalendarIds, isCalendarSelected } = useCalendar();
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedCalendars = availableCalendars.filter(cal =>
    isCalendarSelected(cal.id)
  );

  if (selectedCalendars.length === 0) {
    return null;
  }

  return (
    <div className={styles.calendarUlegend}>
      <div className={styles.calendarUlegendUheader}>
        <h4 className={styles.calendarUlegendUtitle}>Active Calendars</h4>
        <button
          className={styles.calendarUlegendUtoggle}
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label={isExpanded ? 'Collapse' : 'Expand'}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {isExpanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>
      </div>

      {isExpanded && (
        <div className={styles.calendarUlegendUcontent}>
          <div className={styles.calendarUlegendUlist}>
            {selectedCalendars.map(calendar => (
              <div key={calendar.id} className={styles.calendarUlegendUitem}>
                <span
                  className={styles.calendarUlegendUcolor}
                  style={{ backgroundColor: calendar.color_code || 'var(--color-info)' }}
                />
                <span className={styles.calendarUlegendUname}>{calendar.name}</span>
              </div>
            ))}
          </div>

          <div className={styles.calendarUlegendUfooter}>
            <small className={styles.legendUhint}>
              Click on calendar items in the selector to show/hide
            </small>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarLegend;
